import {API_URL} from './base';

export interface ReleaseNote {
    id: number;
    version: string;
    title: string;
    content: string;
    publishedAt: string;
    notifyUsers: boolean;
}

const load = async <T>(path: string): Promise<T> => {
    const response = await fetch(`${API_URL}/api/v2/${path}`, {
        headers: {Accept: 'application/json'},
        cache: 'no-store',
    });

    if (!response.ok) {
        throw new Error(`Could not load release notes: ${response.status}`);
    }

    return response.json() as Promise<T>;
};

export const loadLatestRelease = (): Promise<ReleaseNote | null> =>
    load('release-notes/latest');

export const loadReleases = (): Promise<ReleaseNote[]> => load('release-notes');
